import {FC} from 'react';
import {IonRouterLink} from '@ionic/react';
import formattedDate from '../../utilis/formatDate';
import {minimizeText} from '../../utilis/minimizeText';
import UIIcon from '../UICommon/UIIcon';
import UIImage from '../UICommon/UIImage';

type HomePageCardProps = {
  type: ('gradient' | 'image-text');
  title: string;
  description: string;
  date?: string;
  textSize?: 'big' | 'small';
  icon?: string;
  img?: string;
  href?: string;
  style?: string;
}

const HomePageCard: FC<HomePageCardProps> = ({
  type,
  title,
  description,
  date,
  textSize = 'big',
  icon,
  img,
  href,
  style,
}) => {
  const minimizedDescription = minimizeText(description, 110);

  if (type === 'gradient') {
    return (
      <IonRouterLink routerLink={href} className={`${style} h-full`}>
        <div className='bg-purple-gradient h-full rounded-xl pt-20 pb-16 relative md:max-h-[250px]'>
          <div className='text-white px-7'>
            {icon && (<UIIcon icon={icon} style='bg-gray-transparent rounded-10 p-2 absolute top-7' size='2xl'/>)}
            <div className={`${textSize === 'big' ? 'text-2xl' : 'text-lg'}
             font-semibold font-Outfit mb-2 md:whitespace-nowrap`}>{title}</div>
            <div
              className={`${textSize === 'big' ? 'text-sm' : 'text-xs'}
              font-Outfit leading-4`}
              dangerouslySetInnerHTML={{__html: minimizedDescription}}>
            </div>
          </div>
        </div>
      </IonRouterLink>
    );
  } else {
    return (
      <IonRouterLink routerLink={href} className={style}>
        <div className='rounded-xl relative'>
          {date && (
            <div className=' absolute rounded-40 py-1 px-5 bg-purple-light text-purple-dark
             font-Outfit font-semibold text-sm top-3 left-3'>{formattedDate(date)}</div>
          )}
          <div className='h-64 md:h-36 md:w-full'>
            <UIImage style='rounded-xl' url={img as string}></UIImage>
          </div>
          <div className='absolute md:static h-full md:h-auto md:text-navy-primary
           w-full flex bg-gradient-to-t from-gray-transparent to-transparent
           md:bg-none px-3 text-white text-left bottom-0 rounded-xl md:px-0'>
            <div className='pb-5 md:pb-0 mt-auto md:mt-0'>
              <div className='text-lg font-semibold leading-6 font-Outfit pb-2 md:py-2'>
                {minimizeText(title, 50)}
              </div>
              <div className='font-Outfit font-normal text-base leading-4 md:text-navy-secondary'
                dangerouslySetInnerHTML={{__html: minimizedDescription}}></div>
            </div>
          </div>
        </div>
      </IonRouterLink>
    );
  }
};

export default HomePageCard;
